import React from 'react';
import Link from '../Link';
import makeBodyText from '../../utils/makeText';
import { LINKS_LIST } from '../../constants/menu';
import styles from './index.module.scss';
const ACCOUNT_LINK = LINKS_LIST[LINKS_LIST.length - 1];
const UserImage = ({ isDesktop, userName, userSurname, onLocation, onClick, userImageSize, isWhite }) => {
    const userInitializes = userName && userSurname ? `${userName.substr(0, 1)}${userSurname.substr(0, 1)}` : '';
    const isLarge = userImageSize === 'large';
    const userText = !isLarge ? (React.createElement("span", { className: `${makeBodyText('M')}` }, userInitializes)) : (React.createElement("h5", null, userInitializes));
    return (React.createElement("div", { className: `${styles.userImageWrap} ${isDesktop ? styles.desktopLayout : ''}` },
        isDesktop && React.createElement(Link, Object.assign({}, ACCOUNT_LINK, { onLocation: onLocation, withoutFill: true })),
        React.createElement("button", { id: 'userImage', className: `${styles.userImage} ${styles[userImageSize]} ${isWhite ? styles.whiteBcg : ''}`, onClick: (e) => onClick(e), type: 'button', "aria-label": 'User' }, userText)));
};
export default UserImage;
